// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkAssessmentTypeSchema = z.enum(['DOMAIN_COMPROMISE'] as const);

export type InternalNetworkAssessmentTypeType = `${z.infer<typeof InternalNetworkAssessmentTypeSchema>}`

export default InternalNetworkAssessmentTypeSchema;
